import { addons } from '@storybook/addons';
import { ADDON_ID } from '../constants';

// Register the addon
addons.register(ADDON_ID, () => {});